module.exports = __webpack_public_path__ + "img/fish.07a4e456.png";